import React from 'react';
import LoanCalculatorInputsOnlyComponent from './LoanCalculatorInputsOnly';
import { LoanCalculatorProvider } from '../LoanCalculator/state/LoanCalculatorContext';

const LoanCalculatorInputsOnlyWithProvider: React.FC<any> = (props) => (
  <LoanCalculatorProvider>
    <LoanCalculatorInputsOnlyComponent {...props} />
  </LoanCalculatorProvider>
);

export default LoanCalculatorInputsOnlyWithProvider;
